import React, { useEffect, useState } from "react";
import moment from "moment";
import HomeMatchResultBadge from "./HomeMatchResultBadge";

function HomeMiddleCardsSection({ unDiaComoHoy, revealed }) {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        setCurrentIndex(0);
    }, [unDiaComoHoy]);

    const totalPartidos = unDiaComoHoy.length;
    const partido = totalPartidos > 0 ? unDiaComoHoy[currentIndex] : null;

    const goToPrevious = () => {
        if (totalPartidos === 0) {
            return;
        }

        setCurrentIndex((prevIndex) => (prevIndex - 1 + totalPartidos) % totalPartidos);
    };

    const goToNext = () => {
        if (totalPartidos === 0) {
            return;
        }

        setCurrentIndex((prevIndex) => (prevIndex + 1) % totalPartidos);
    };

    const getScoreDisplay = (partidoData) => {
        const aguadaScore = Number(partidoData?.totalAguadaStats?.totalPuntos);
        const rivalScore = Number(partidoData?.totalAdversarioStats?.totalPuntos);

        if (Number.isNaN(aguadaScore) || Number.isNaN(rivalScore)) {
            return <p className="text-lg font-bold mb-6 text-white tracking-wide">{partidoData.resultado}</p>;
        }

        const localTeam = partidoData.local ? 'Aguada' : partidoData.adversario;
        const awayTeam = partidoData.local ? partidoData.adversario : 'Aguada';
        const localScore = partidoData.local ? aguadaScore : rivalScore;
        const awayScore = partidoData.local ? rivalScore : aguadaScore;

        const localScoreClass = localScore > awayScore ? 'text-green-400' : localScore < awayScore ? 'text-red-400' : 'text-white';
        const awayScoreClass = awayScore > localScore ? 'text-green-400' : awayScore < localScore ? 'text-red-400' : 'text-white';

        return (
            <p className="text-lg font-bold mb-2 text-white tracking-wide">
                <span>{localTeam} </span>
                <span className={localScoreClass}>{localScore}</span>
                <span> - </span>
                <span className={awayScoreClass}>{awayScore}</span>
                <span> {awayTeam}</span>
            </p>
        );
    };

    return (
        <div
            className="relative overflow-hidden bg-white/5 backdrop-blur-xl border border-white/20 shadow-2xl rounded-2xl p-5 sm:p-8 md:col-span-2 lg:col-span-1 transition-all duration-700 ease-out"
            style={{ opacity: revealed ? 1 : 0, transform: revealed ? 'translateX(0)' : 'translateX(2rem)', transitionDelay: revealed ? '200ms' : '0ms' }}
        >
            <span className="pointer-events-none absolute left-0 top-0 h-0.5 w-1/2 bg-green-400"></span>
            <span className="pointer-events-none absolute bottom-0 right-0 h-0.5 w-1/3 bg-red-500"></span>
            <h3 className="text-white font-bold uppercase tracking-widest text-sm mb-6 text-center drop-shadow-sm">Un día como hoy...</h3>
            {partido ? (
                <div className="flex items-center justify-between flex-1">
                    {totalPartidos > 1 && (
                        <button
                            className="p-2 hover:bg-white/15 rounded-full transition-colors text-white border border-white/10"
                            onClick={goToPrevious}
                            aria-label="Partido anterior"
                        >
                            ‹
                        </button>
                    )}
                    <div className="text-center px-4 flex-1">
                        <p className="text-slate-400 text-sm font-semibold mb-1">{moment(partido.fecha).format('DD/MM/YYYY')}</p>
                        <p className="text-white font-medium mb-4 text-sm">{partido.liga} - {partido.temporadaRegular ? "Temp. Reg. Fecha " + partido.fechaLiga :
                            partido.playoffsEtapa ? partido.playoffsEtapa + " Partido " + partido.fechaLiga :
                                partido.superLiga ? "SuperLiga Fecha " + partido.fechaLiga :
                                    partido.liguilla ? "Liguilla Fecha " + partido.fechaLiga :
                                        partido.reclasificatorio ? "Reclasificatorio Fecha " + partido.fechaLiga :
                                            partido.fase + " Partido " + partido.fechaLiga}</p>
                        {getScoreDisplay(partido)}
                        <p className="text-slate-400 text-xs mb-6 uppercase tracking-wider font-semibold">En {partido.cancha} como {partido.local ? 'Local' : 'Visitante'}</p>
                        <div className="mb-6">
                            <HomeMatchResultBadge partido={partido} />
                        </div>
                        <a href={`partido/${partido._id}`} className="group relative inline-flex w-full items-center justify-between overflow-hidden rounded-xl border border-white/25 bg-white/5 py-1.5 pl-4 text-sm font-bold uppercase tracking-wide text-white transition-all duration-300 hover:border-white/50 hover:bg-white/10">
                            <span className="absolute left-0 top-0 h-0.5 w-1/2 bg-green-400"></span>
                            <span className="absolute bottom-0 right-0 h-0.5 w-1/3 bg-red-500"></span>
                            <span>Ver estadísticas</span>
                            <span className="flex h-9 w-10 items-center justify-center text-xl text-green-400 transition-all duration-300 group-hover:translate-x-1 group-hover:text-red-400" aria-hidden="true">&#8594;</span>
                        </a>
                        {totalPartidos > 1 && (
                            <p className="text-xs text-slate-400 mt-3">{currentIndex + 1} / {totalPartidos}</p>
                        )}
                    </div>
                    {totalPartidos > 1 && (
                        <button
                            className="p-2 hover:bg-white/15 rounded-full transition-colors text-white border border-white/10"
                            onClick={goToNext}
                            aria-label="Siguiente partido"
                        >
                            ›
                        </button>
                    )}
                </div>
            ) : (
                <p className="text-center my-[4.18rem] text-slate-300">No se jugaron partidos un día como hoy</p>
            )}
        </div>
    );
}

export default HomeMiddleCardsSection;
